module.exports = __webpack_public_path__ + "img/sd.2c8d42b5.svg";